<div class="column-header-container" [ngStyle]="{ 'max-width': (params.column.actualWidth-30).toString() + 'px' }"
    [matTooltip]="isTextHasEllipsis(textInformation) ? params.displayName : undefined" matTooltipClass="custom-tooltip-text" matTooltipPosition="after">
    <div (click)="onSortRequested($event)" class="custom-header-label">
        <span #textInformation class="custom-header-text" [id]="this.id">{{ params.displayName }}</span>
        <span class="customeHeaderSort sortIcons mb-0 float-left">
            <svg *ngIf="ascSort" class="icon-10" style="fill: #758994;">
                <use href="../App_Themes/CXone/icons/arrow-up.svg#arrow-up"></use>
            </svg>
            <svg *ngIf="descSort" class="icon-10" style="fill: #758994;">
                <use href="../App_Themes/CXone/icons/arrow-down.svg#arrow-down"></use>
            </svg>
        </span>
    </div>
    <div *ngIf="params.enableMenu" #menuButton class="custom-header-menu-button" [ngStyle]="{ 'left': (params.column.actualWidth -30).toString() + 'px' }" (click)="onMenuClicked()">
        <span class="ag-icon ag-icon-menu"></span>
    </div>
</div>